<template>
    <div class="profile-with-shapes-card" :data-testid="`profiles-with-shapes-card-${index}`">
        <MktCardHand class="profile-with-shapes-card__hand" :ms-theme="theme === 'strategy'">
            <MktMaltPrismicImage :image-field="profile.image" :data-testid="`profiles-with-shapes-card-${index}-image`" />
        </MktCardHand>
        <div>
            <div class="profile-with-shapes-card__name" :data-testid="`profiles-with-shapes-card-${index}-name`">{{ profile.name }}</div>
            <div class="profile-with-shapes-card__job" :data-testid="`profiles-with-shapes-card-${index}-job`">{{ profile.job }}</div>
            <div :class="{'profile-with-shapes-card__info': true, 'profile-with-shapes-card__info--has-malt-theme': theme === 'malt'}">
                <strong :data-testid="`profiles-with-shapes-card-${index}-title1`">{{ profile.title1 }}</strong>
                <PrismicRichText :field="profile.text1" :data-testid="`profiles-with-shapes-card-${index}-text1`" />
                <strong v-if="profile.title2" :data-testid="`profiles-with-shapes-card-${index}-title2`">{{ profile.title2 }}</strong>
                <p v-if="profile.text2" :data-testid="`profiles-with-shapes-card-${index}-text2`">{{ profile.text2 }}</p>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import {PrismicRichText} from '@prismicio/vue';
    import type {ProfilesSliceProfilesWithShapesPrimaryProfilesItem} from '@prismicio-types';
    import {MktCardHand, MktMaltPrismicImage} from '#components';

    defineProps<{
        profile: ProfilesSliceProfilesWithShapesPrimaryProfilesItem;
        theme: 'malt' | 'strategy';
        index: number;
    }>();
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .profile-with-shapes-card {
        margin: var(--joy-core-spacing-8) auto 0;
        text-align: center;
        padding: 0 var(--joy-core-spacing-12);
        border-radius: var(--joy-core-radius-4);

        &__hand {
            margin: 0 auto var(--joy-core-spacing-6);
            user-select: none;
        }

        &__info {
            margin: var(--joy-core-spacing-5) auto 0;
            max-width: 256px;

            strong {
                display: block;
                margin-top: var(--joy-core-spacing-4);
                color: var(--joy-color-secondary-30);
                font-size: var(--joy-font-size-primary-200);
                font-weight: var(--joy-font-weight-bold);
                text-transform: uppercase;
                letter-spacing: -0.12px;
                user-select: none;
            }

            &--has-malt-theme {
                strong {
                    color: var(--joy-color-neutral-60);
                }
            }

            p {
                margin-top: var(--joy-core-spacing-1);
                color: var(--joy-color-neutral-40);
                letter-spacing: -0.16px;
            }
        }

        &__name {
            font-family: var(--joy-font-family-title);
            color: var(--joy-color-text-heading);
            font-size: var(--joy-font-size-secondary-200);
            line-height: var(--joy-line-height-small);
        }

        &__job {
            margin-top: var(--joy-core-spacing-2);
            color: var(--joy-color-neutral-40);
            font-size: var(--joy-font-size-primary-400);
            font-weight: var(--joy-font-weight-bold);
            letter-spacing: -0.16px;
            line-height: var(--joy-line-height-small);
        }
    }
</style>
